import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d8c215f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center",
  style: {"margin-bottom":"1.5rem"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shadow rounded" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center avatar-huge" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "spinner-border spinner-border text-primary",
      role: "status",
      "aria-hidden": "true"
    })
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "flex-column avatar avatar-huge cursor-pointer border border-4 border-card shadow rounded d-flex align-items-center justify-content-center bg-secondary-soft" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "fa-solid fa-image fa-2xl text-secondary"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "position-absolute rounded-circle bg-secondary border border-4 border-card shadow d-flex justify-content-center align-items-center update-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-pen text-white" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageCropper = _resolveComponent("ImageCropper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.uploading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModalForFile && _ctx.openModalForFile(...args))),
          class: "d-flex justify-content-center align-items-center mb-4"
        }, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.image)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.image,
                  class: "avatar-img rounded"
                }, null, 8, _hoisted_5))
              : (_openBlock(), _createElementBlock("i", _hoisted_6)),
            _hoisted_7
          ])
        ])),
    _createVNode(_component_ImageCropper, {
      modalId: `${_ctx.inputId}_modal`,
      accept: '.jpeg,.png,.jpg',
      aspectRatio: 1 / 1,
      onCropEnd: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fileUploaded($event))),
      inputId: _ctx.inputId,
      hiddenInput: true,
      backdrop: "false"
    }, null, 8, ["modalId", "inputId"])
  ], 64))
}